var React = require('react');

function ArrowUpAlt (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.8867 6.41992L6.06641 0.599609L0.246093 6.41992L1.31055 7.48437L5.31445 3.46094V14.9941H6.81836V3.46094L10.8223 7.48437L11.8867 6.41992Z","fill":"white"}));
}

ArrowUpAlt.defaultProps = {"width":"12","height":"15","viewBox":"0 0 12 15","fill":"none"};

module.exports = ArrowUpAlt;

ArrowUpAlt.default = ArrowUpAlt;
